import React from 'react'

const CallToAction = () => {
  return (
    <section className="admn-cta">
      <div className="container">
        <div className="admn-cta__box">
          <p className="admn-cta__content">Want personalized guidance for college admissions?</p>
          <a href='/contact' className="admn-cta-btn admn-cta-btn--gradient">Get Personalized Guidance</a>
        </div>
      </div>
    </section>
  )
}

export default CallToAction


/** WEBPACK FOOTER **
 ** ./src/components/CallToAction/CallToAction.js
 **/